import React, { useContext, useEffect, useState } from "react";
import { Tabs, Tab, Nav, Modal, Button, Table, Form } from "react-bootstrap";
import settingw from "../../assets/setting-white.svg";
import docGrey from "../../assets/doc-grey.svg";
import backImg from "../../assets/back.svg";
import { processType } from "../../utils/constant";
import {
  handleDeclineRFQ,
  getRFQByRFQRefId,
  uploadRFQDocument,
  deleteRFQDocument,
  createOfferAcceptedPO,
  declineOffer,
  ReturnSubmitQuotations,
  getEightXAddress,
} from "../../utils/actions/userActions";
import { Link, useNavigate, useParams, Redirect } from "react-router-dom";
import {
  calculateTaxAmount,
  calculateTotalAmountFromParts,
  calculateTotalPriceWithTaxes,
  convertAdminPriceToCustomer,
  currencyFormatter,
  downloadFileFromS3,
  extractURLAndEncodedFilename,
  numberInputOnWheelPreventChange,
  validateUser,
} from "../../utils/helper";
import { toast } from "react-toastify";
import moment from "moment";
import HoverInfo from "../../component/HoverInfo/HoverInfo";
import { OrdersContext } from "../../context/orders.context";
import ChatButton from "../../component/Chat/ChatButton";
import Chat from "../../component/Chat";
import qs from "query-string";
import { Loading } from "../../component/Loading";
import { DeleteIcon, DownloadIcon, LucidLoader } from "../../component/icons";
import ThreeDViewerComponent from "../../component/ThreeDViewerComponent/ThreeDViewerComponent";
import FileName from "../../component/FileName";
import { ChatRefContext } from "../../context/chatRef.context";
import { getPresignedUrlForFile } from "../../helperApi/helperApi";
import PDFModalViewer from "../../component/PDFViewerModal/PDFModalViewer";
import DisplayDimensions from "../../component/DisplayDimensions/DisplayDimensions";

const OfferDetails = () => {
  const loggedInUserToken = localStorage.getItem("Token");
  const [isValidUser, setIsValidUser] = useState(true);
  const [selectedRFQ, setSelectedRFQ] = useState({});
  const [isloading, setIsloading] = useState(false);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [showReviewQuoteModal, setShowReviewQuoteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const { search } = window.location;
  const param = qs.parse(search);
  const navigate = useNavigate();
  const [open, setOpen] = useState(param.chat);
  const {
    refresh,
    setRefresh,
    activeTab,
  } = useContext(OrdersContext);
  const { setSelectedChatRefId, selectedChatRefId } = useContext(ChatRefContext);
  const [showRedirectModal, setShowRedirectModal] = useState(false);
  let userId = localStorage.getItem("_id");
  let email = localStorage.getItem("email");
  const [pdfModalInfo, setPdfModalInfo] = useState({
    show: false,
    fileName: '',
    pdfUrl: ''
  });
  const [taxes, setTaxes] = useState([]);


  useEffect(() => {
    let isLoggedInUser = validateUser(navigate);
    if (isLoggedInUser) {
      if (id) {
        setLoading(true);
        fetchData();
      }
    }
  }, []);

  const fetchData = async () => {
    try {
      const response = await getRFQByRFQRefId(id, loggedInUserToken);
      if (
        response.data &&
        response.data.rfqOfferId?.partsData &&
        response.data.partsData
      ) {
        // Map unitPrice from rfqOfferId.partsData to outer partsData array
        response.data.partsData = response.data.partsData.map((part, index) => {
          const price = response.data.partsData[index]?.price || 0; // Fallback to 0 if unitPrice is missing
          return {
            ...part,
            price, // Add or overwrite the unitPrice
          };
        });

        const offerData = response.data;

        const supplier = offerData?.supplierId;

        const derivedTaxes = [
          {
            label: supplier?.taxesLabel,
            tax: Number(supplier?.taxes) || 0,
          },
          {
            label: supplier?.taxes2Label,
            tax: Number(supplier?.taxes2) || 0,
          },
        ].filter((t) => t.tax > 0);

        setTaxes(derivedTaxes);

        setSelectedRFQ(offerData);
        if (
          response.data.status == "Cancelled" ||
          response.data.status == "Active Order"
        ) {
          setShowRedirectModal(true);
        }
      } else {
        toast.error(
          "Quotation data not found.Please contact us at admin to resolve the issue."
        );
        navigate("/my-orders");
        return;
      }

      let supplierLoggedIn = localStorage.getItem("supplierId");
      if (!supplierLoggedIn) {
        toast.error(
          "Something went wrong with loggedIn Credentials.Please login again."
        );
      } else {
        if (supplierLoggedIn != response.data.supplierId._id) {
          setIsValidUser(false);
        }
      }

      setLoading(false);
    } catch (err) {
      console.log("err", err);
      setLoading(false);
      toast.error("Something went wrong");
    }
  };


  const handleItemNotesChange = (event, index) => {
    let localPartsData = [...selectedRFQ.partsData];
    localPartsData[index].notes = event.target.value;
    setSelectedRFQ({ ...selectedRFQ, partsData: localPartsData });
  };

  const handlePartNotesChange = (event, index) => {
    let localPartsData = [...selectedRFQ.partsData];
    localPartsData[index].partNotes = event.target.value;
    setSelectedRFQ({ ...selectedRFQ, partsData: localPartsData });
  };

  const handleDescriptionChange = (event, index) => {
    let localPartsData = [...selectedRFQ.partsData];
    localPartsData[index].description = event.target.value;
    setSelectedRFQ({ ...selectedRFQ, partsData: localPartsData });
  };

  const handleItemPriceChange = (event, index) => {
    let localPartsData = [...selectedRFQ.partsData];
    localPartsData[index].price = event.target.value;
    let totalPrice = localPartsData?.reduce((acc, item) => {
      return acc + item.price * item.qty;
    }, 0);

    setSelectedRFQ({
      ...selectedRFQ,
      partsData: localPartsData,
      price: totalPrice,
    });
  };

  const validateRFQData = () => {
    let isDataValid = true;
    let isPriceAvailable = false;

    for (let i = 0; i < selectedRFQ.partsData.length; i++) {
      if (selectedRFQ.partsData[i].unitPrice > 0) {
        isPriceAvailable = true;
        break;
      }
    }

    if (isPriceAvailable) {
      isDataValid = true;
    } else {
      isDataValid = false;
    }

    if (!selectedRFQ.leadTime) {
      isDataValid = false;
    }

    return isDataValid;
  };

  const handleCreatePurchaseOrder = async (rfqSelectedForPO) => {
    try {
      let formData = new FormData();
      const addressData = await getEightXAddress(loggedInUserToken);
      formData.append("rfqData", JSON.stringify(rfqSelectedForPO));
      formData.append("shippingAddress", JSON.stringify(addressData.data[0]));
      const poResponse = await createOfferAcceptedPO(
        formData,
        loggedInUserToken
      );
      if (poResponse?.data?.status) {
        toast.success(
          "Offer accepted successfully, a purchase order will be sent to you shortly"
        );
        // toast.success(poResponse?.data?.message);
        navigate(`/dashboard`);
      } else {
        toast.error(poResponse?.data?.message);
      }
    } catch (err) {
      console.log(
        "Error in 257 Offer Details on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleDeclineClick = () => {
    setShowDeclineModal(true); // Show the modal
  };

  const handleDeclineModalClose = () => {
    setShowDeclineModal(false); // Close the modal
  };

  const handleSubmitQuotation = async () => {
    try {
      const rfqData = {
        supplierId: selectedRFQ.supplierId._id,
        createdBy: loggedInUserToken, // Assuming logged-in user's token is the creator
      };

      // API call to create RFQ
      const response = await createRFQ(rfqData);

      if (response?.status) {
        toast.success("RFQ created successfully!");
        // Optionally refresh or fetch new data
        // fetchNewValues();
      } else {
        toast.error(response.message || "Failed to create RFQ");
      }

      setShowDeclineModal(false); // Close modal after action
    } catch (error) {
      console.error("Error creating RFQ:", error);
      toast.error("An error occurred while creating the RFQ");
    }
  };

  const handleDeclineWithoutQuotation = async () => {
    try {
      setIsloading(true);
      setShowDeclineModal(false);
      const id = selectedRFQ.supplierId._id;
      const response = await declineOffer(id, loggedInUserToken);
      if (response?.status) {
        toast.success("Offer declined");
        setShowDeclineModal(false); // Close the modal
        // Additional logic can go here (e.g., refresh data)
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("Error declining offer:", err);
      toast.error("Failed to decline offer.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitQuote = async () => {
    try {
      const supplierid = selectedRFQ._id;
      const isValidData = validateRFQData();

      // Create a new FormData object
      let formData = new FormData();

      // Append the necessary fields to the FormData object

      // Validate form data before submitting
      setIsloading(true);
      let response = await ReturnSubmitQuotations(
        selectedRFQ,
        supplierid,
        loggedInUserToken
      );

      if (response.status) {
        toast.success("Quotation is submitted successfully.");

        // Navigate based on the active tab
        if (activeTab) {
          navigate(`/my-orders?status=${activeTab}`);
        } else {
          navigate(`/my-orders`);
        }

        // Refresh the data
        setRefresh(refresh + 1);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.log("Error:", err);
      toast.error("An error occurred while submitting the quote.");
    }
    finally {
      setIsloading(false);

    }
  };

  const handleLeadTimeChange = (e) => {
    setSelectedRFQ({ ...selectedRFQ, leadTime: e.target.value });
  };

  const onClose = () => {
    setSelectedChatRefId(null);
  };

  const handleUploadRFQDocument = async (e) => {
    try {
      let rfqOfferDocument = e.target.files[0];
      let formData = new FormData();
      formData.append("rfqOfferId", selectedRFQ._id);
      formData.append("rfqOfferDocument", rfqOfferDocument);

      const uploadRFQDocResponse = await uploadRFQDocument(
        loggedInUserToken,
        formData
      );
      if (uploadRFQDocResponse.status) {
        toast.success("Document uploaded ");
        setSelectedRFQ({
          ...selectedRFQ,
          rfqOfferDocument: uploadRFQDocResponse?.data?.rfqOfferDocument,
        });
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleRFQDocumentDelete = async () => {
    try {
      const deleteDocResponse = await deleteRFQDocument(
        loggedInUserToken,
        selectedRFQ._id
      );
      if (deleteDocResponse.data.status) {
        setSelectedRFQ({ ...selectedRFQ, rfqOfferDocument: null });
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const RedirectComponent = () => {
    const [countdown, setCountdown] = useState(3);

    useEffect(() => {
      const timer = setTimeout(() => {
        navigate("/my-orders");
      }, countdown * 1000);

      return () => clearTimeout(timer);
    }, [countdown, navigate]);

    useEffect(() => {
      if (countdown > 0) {
        const countdownTimer = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);

        return () => clearInterval(countdownTimer);
      }
    }, [countdown]);

    return <div>Redirecting in {countdown} seconds...</div>;
  };

  const handleUnitPriceChange = (e, id) => {
    const value = Number(e.target.value) || 0;

    setSelectedRFQ((prev) => {
      if (!prev?.partsData) return prev;

      // ✅ Update only the changed part
      const updatedPartsData = prev.partsData.map((part) =>
        part._id === id
          ? { ...part, price: value } // immutable update
          : part
      );

      // ✅ Calculate total WITH taxes
      const totalPrice = calculateTotalAmountFromParts(
        updatedPartsData,
        taxes
      );

      return {
        ...prev,
        partsData: updatedPartsData,
        price: totalPrice,        // RFQ total
        offerPrice: totalPrice,   // Offer total (same logic)
      };
    });
  };

  const showPricingAccordingToCurrency = (price) => {
    //convert the price
    console.log('Selected rfq ::', selectedRFQ);
    const { currencySnapshot } = selectedRFQ || {};
    const customerRate = currencySnapshot?.customerRate;
    const convertedPrice = convertAdminPriceToCustomer(price, customerRate);
    console.log('Converted price ::', convertedPrice);
    return currencyFormatter(convertedPrice);
  }

  return (
    <div className="content-wrapper">
      <Chat
        RefId={selectedRFQ.supplierRFQRefId || id}
        open={selectedChatRefId}
        onDrawerClose={onClose}
      />
      <PDFModalViewer
        show={pdfModalInfo.show}
        handleClose={() => setPdfModalInfo({ show: false, fileName: '', pdfUrl: '' })}
        fileName={pdfModalInfo.fileName}
        pdfUrl={pdfModalInfo.pdfUrl}
      />
      {selectedRFQ !== "Under Review" && (
        <Modal
          size="md"
          dialogClassName="quote-version-modal"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showDeclineModal}
          onHide={() => setShowDeclineModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="text-2xl font-bold"
            >
              Submit Quotation?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-lg">
              Do you wish to submit quotation for this offer?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button
              style={{
                color: "white",
                fontWeight: "500",
                backgroundColor: "#00c389",
              }}
              className="px-4 py-2 bg-blue-500 rounded text-white font-medium"
              onClick={() => {
                setShowDeclineModal(false); // Close confirmation modal
                setShowReviewQuoteModal(true); // Open review modal
              }}
            >
              Yes, Submit Quotation
            </button>
            <button
              style={{ color: "red", fontWeight: "500", marginRight: "0px" }}
              className="px-4 py-2 rounded font-medium white-btn border"
              onClick={handleDeclineWithoutQuotation}
            >
              Decline Offer
            </button>
          </Modal.Footer>
        </Modal>
      )}

      {isValidUser && !loading ? (
        <>
          <div className="intro-bar-rfq">
            <div className="int-left-rfq">
              <div
                className="left-item"
                style={{ marginRight: "40px", cursor: "pointer" }}
                onClick={() => navigate(-1)}
              >
                <img src={backImg} height="15px" />
              </div>

              <div className="left-item">
                <p className="p-header">
                  Offer ID : {selectedRFQ.supplierRFQRefId}
                </p>
                <p
                  className={
                    selectedRFQ.status == "Pending for Quotation"
                      ? "pending-for-quotation"
                      : selectedRFQ.status == "Under Review"
                        ? "under-review"
                        : selectedRFQ.status == "Unapproved"
                          ? "unapproved-quotes"
                          : ""
                  }
                >
                  {selectedRFQ.status}
                </p>
              </div>

              <div className="left-item">
                <p className="p-header">REQUESTED DATE</p>
                <p>{moment(selectedRFQ.receivedDate).format("DD MMM YYYY")}</p>
              </div>
            </div>

          </div>

          <div className="dashboard-holder ">
            <div className="lg-container -translate-y-10">
              {/* <Chat RefId={RefId} open={open} onDrawerClose={onClose} /> */}
              <div className="common-bx">
                <div
                  className={
                    selectedRFQ.status == "Under Review"
                      ? "process-bar-bx green-line"
                      : "process-bar-bx grey-line"
                  }
                >
                  <span className="process-ico green-fill">
                    <img src={settingw} />
                  </span>
                  <div
                    style={{
                      maxWidth: "500px",
                      wordWrap: "break-word",
                      wordBreak: "break-all",
                      whiteSpace: "normal",
                      position: "absolute",
                      right: "150px",
                    }}
                  >
                    <span
                      className="text"
                      style={{
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "bolder",
                      }}
                    >
                      Project Name
                    </span>
                    <div
                      className="name"
                      style={{ color: "#000", fontSize: "14px" }}
                    >
                      {selectedRFQ?.rfqOfferId?.projectName || "Not Found"}
                    </div>
                  </div>
                  <h5>Requirements</h5>
                  <p style={{ color: "#333333", fontSize: "12px" }}>
                    {moment(selectedRFQ.createdAt).format("DD MMM YYYY")}
                  </p>

                  <h6
                    className="box-in-quote-version"
                    style={{ color: "#333333" }}
                  >
                    MFG. Process :{" "}
                    {selectedRFQ?.rfqOfferId?.selectedProcess
                      ? processType[selectedRFQ?.rfqOfferId?.selectedProcess - 1]
                        .name
                      : null}
                  </h6>

                  <div className="version-tabs overflow-x-auto" >
                    <table className="qoute-version-table">
                      <thead>
                        <tr className="heading-row">
                          <th scope="col">Snapshot</th>
                          <th scope="col">Files</th>
                          <th scope="col">Description</th>
                          <th scope="col">Notes</th>
                          <th scope="col">Unit Price</th>
                          {taxes.length > 0 &&
                            taxes.map(({ label }) => {
                              return (
                                <th scope="col" >{label}</th>
                              );
                            })}
                          <th scope="col">Qty</th>
                          <th scope="col">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedRFQ?.partsData?.length > 0 &&
                          selectedRFQ.partsData.map((item, index) => {
                            console.log("Two d file ::", item?.twoDFile);
                            return (
                              <tr key={index}>
                                <td style={{ minWidth: "150px" }}>
                                  <p className="text-sm bold text-center h-28 ">
                                    <ThreeDViewerComponent
                                      item={item}
                                      selectedProcess={selectedRFQ?.rfqOfferId?.selectedProcess}
                                      additionalClasses={'!border-0'}

                                    />
                                  </p>
                                </td>
                                <td
                                  style={{ minWidth: "250px" }}
                                >
                                  <div
                                    className="prd-thumb downloadables"
                                    style={{ color: "dodgerblue" }}
                                  >
                                    <p style={{ color: "dodgerblue" }}>
                                      {item.selectedFile ?
                                        <> <FileName
                                          onDownload={async () => {
                                            const { originalname } = item.selectedFile;
                                            if (originalname && originalname.endsWith('.pdf')) {
                                              const signedUrl = await getPresignedUrlForFile(item.selectedFile.bucket, item.selectedFile.key);
                                              console.log('Signed URL for PDF:', signedUrl);
                                              setPdfModalInfo({
                                                show: true,
                                                pdfUrl: signedUrl,
                                                fileName: originalname,
                                              })
                                              return;
                                            }

                                            await downloadFileFromS3(item?.selectedFile)
                                          }}
                                          fileName={item.selectedFile?.originalname}
                                        />
                                        </> : (
                                          "File Not Available"
                                        )}
                                    </p>
                                  </div>
                                  <div
                                    className="prd-thumb downloadables"
                                    style={{ color: "dodgerblue" }}
                                  >
                                    <p style={{ color: "dodgerblue" }}>
                                      {item.twoDFile?.originalname ? (
                                        <>
                                          <FileName
                                            onDownload={async () => {
                                              const { originalname } = item?.twoDFile;
                                              if (originalname && originalname.endsWith('.pdf')) {
                                                const signedUrl = await getPresignedUrlForFile(item?.twoDFile.bucket, item?.twoDFile.key);
                                                console.log('Signed URL for PDF:', signedUrl);
                                                setPdfModalInfo({
                                                  show: true,
                                                  pdfUrl: signedUrl,
                                                  fileName: originalname,
                                                })
                                                return;
                                              }
                                              await downloadFileFromS3(item?.twoDFile)
                                            }}
                                            fileName={item.twoDFile?.originalname}
                                          />
                                        </>
                                      ) : (
                                        "File Not Available"
                                      )}
                                    </p>
                                  </div>
                                  {item?.selectedFile && (
                                    <DisplayDimensions
                                      item={item}
                                    />
                                  )}
                                </td>
                                <td style={{ minWidth: "270px" }}>
                                  <textarea
                                    className="border p-1"
                                    placeholder="Enter description here"
                                    style={{ width: "100%", height: "100px" }}
                                    value={item?.description}
                                    onChange={(e) =>
                                      handleDescriptionChange(e, index)
                                    }
                                    maxLength={200}
                                  />
                                </td>
                                <td style={{ minWidth: "230px" }}>
                                  <textarea
                                    className="border p-1"
                                    placeholder="Enter notes here"
                                    style={{ width: "100%", height: "100px" }}
                                    value={item?.notes}
                                    onChange={(e) =>
                                      handleItemNotesChange(e, index)
                                    }
                                    maxLength={200}
                                  />
                                </td>
                                <td style={{ minWidth: "100px" }}>
                                  <div className="flex justify-center gap-x-2">
                                    <input
                                      className="border grow p-1 "
                                      placeholder="Enter price"
                                      value={item.price || ""} // Fallback to empty string if undefined
                                      name="price"
                                      style={{
                                        width: "60px",
                                        marginBottom: "15px",
                                      }}
                                      onWheel={numberInputOnWheelPreventChange}
                                      onKeyDown={(e) =>
                                        ["e", "E", "+", "-"].includes(e.key) &&
                                        e.preventDefault()
                                      }
                                      onChange={(e) => {
                                        handleUnitPriceChange(e, item._id);
                                      }}
                                    />
                                  </div>
                                </td>
                                {taxes.length > 0 &&
                                  taxes.map((_, taxIndex) => {
                                    const taxPercent = Number(item?.[`tax${taxIndex + 1}`]) || 0;
                                    const price = Number(item?.price) || 0;
                                    const taxAmount = calculateTaxAmount(price, taxPercent);

                                    return (
                                      <td
                                        key={taxIndex}
                                        style={{ minWidth: "100px", }}
                                      >
                                        <div className="flex justify-center gap-x-2">
                                          <p>
                                            {showPricingAccordingToCurrency(taxAmount)}

                                          </p>
                                        </div>
                                      </td>
                                    );
                                  })}
                                <td style={{ minWidth: "70px" }}>
                                  <p >{item.qty || ""}</p>
                                </td>

                                <td style={{ minWidth: "100px" }}>
                                  <div className="amt">
                                    <p className="un-fld">
                                      {showPricingAccordingToCurrency(calculateTotalPriceWithTaxes(item, taxes))}

                                    </p>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="mt-3  flex justify-end ">
                    <div>
                      <div className="flex items-center gap-x-2 justify-center ">
                        <div className="grow">
                          <p
                            style={{
                              color: "#333333",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            Lead Time (in Days):
                          </p>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              marginTop: "-10px",
                            }}
                          >
                            <div
                              className="apply-check"
                              style={{ marginRight: "80px" }}
                            >
                              <input
                                className="border p-1"
                                type="number"
                                style={{ fontSize: "13px" }}
                                onWheel={numberInputOnWheelPreventChange}
                                onKeyDown={(e) =>
                                  ["e", "E", "+", "-"].includes(e.key) &&
                                  e.preventDefault()
                                }
                                onChange={handleLeadTimeChange}
                                placeholder="Lead time in Days"
                                value={
                                  selectedRFQ.leadTime
                                    ? selectedRFQ.leadTime
                                    : ""
                                }
                              />
                              {selectedRFQ.leadTime ? (
                                <div style={{ fontSize: "13px" }}>
                                  ({" "}
                                  {Math.floor(selectedRFQ.leadTime / 7) +
                                    "-" +
                                    (Math.floor(selectedRFQ.leadTime / 7) + 1) +
                                    " weeks"}{" "}
                                  )
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="total-amount-order  grow w-[180px]  ">
                          <h6 className="order-price h-10 ">
                            <div> Total : </div>
                            <div className="mt-2">
                              {/*  */}
                              {selectedRFQ.offerPrice ? (
                                showPricingAccordingToCurrency(Number(
                                  selectedRFQ.offerPrice
                                ))
                              ) : (
                                "0"
                              )}
                            </div>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="order-pay-box">
                  <span className="order-ico">
                    <img src={docGrey} />
                  </span>
                  <h5>Order Details</h5>
                  {selectedRFQ.status == "Under Review" ? (
                    <div
                      style={{
                        background: "#DEE2E6",
                        padding: "20px 30px",
                        borderRadius: "5px",
                        fontSize: "14px",
                      }}
                    >
                      <h6>Your quote is under review.</h6>
                      <p>
                        Your quotation has been submitted successfully. If your
                        quote is accepted, we will send you a Purchase Order
                      </p>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="d-flex justify-content-end gap-2">
                  {!isloading ? <button
                    onClick={handleSubmitQuote}
                    style={{
                      color: "white",
                      fontWeight: "500",
                      backgroundColor: "#00c389",
                    }}
                    className={`px-3 py-2 mt-4  float-end rounded flex justify-center items-center ${selectedRFQ.status === "Unapproved"
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-primaryColor"
                      }`}
                  >
                    Submit Quotation
                  </button> :
                    <button
                      style={{
                        color: "white",
                        fontWeight: "500",
                      }}
                      className={`px-3 py-2 mt-4 w-44  float-end rounded flex justify-center items-center bg-gray-400 cursor-not-allowed`}
                    >
                      <LucidLoader />
                    </button>


                  }
                </div>
              </div>
            </div>
          </div>
        </>
      ) : loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          <div className="dashboard-holder">
            <div className="sm-container">
              <div className="dashboard-option">
                <div className="dash-left">
                  <div className="ds-heading">
                    <Link to="/dashboard">
                      <p className="req-quote-btn">Go To DashBoard </p>
                    </Link>
                  </div>
                </div>

                <div style={{ textAlign: "center" }}>
                  <h2>Quotation information is not available</h2>
                  <br />
                  <p>Your dont have access to this quote version details.</p>
                </div>
              </div>
            </div>
          </div>
        </>
      )
      }
    </div >
  );
};

export default OfferDetails;
